import type { ReactNode } from 'react'
import Dotdotdot, { type DotdotdotProps } from 'react-dotdotdot'

export interface WithDotDotDotProps extends DotdotdotProps {
  children: ReactNode
  condition: boolean
}

const WithDotDotDot = ({
  condition,
  children,
  clamp,
  ...rest
}: WithDotDotDotProps) =>
  condition ? (
    <Dotdotdot clamp={clamp || 1} {...rest}>
      {children}
    </Dotdotdot>
  ) : (
    <>{children}</>
  )

export default WithDotDotDot
